// The API retains detailed source sections for audit; normal sharing presents
// their already-authorized values without recalculating or mutating saved facts.
export function businessSections(report) {
  const rowPayments = report.sections.some(section => section.key === 'manual-payments');
  return report.sections.flatMap(section => {
    if (rowPayments && ['manual-payments','billing-payments'].includes(section.key)) return [];
    if (rowPayments && section.key === 'payments') {
      const labels = {'Cash received':'Cash','UPI/GPay received':'UPI/GPay','Card received':'Card','Due · not cash received':'Due','Non-Billing Aggregator/Online · sale, not cafe cash or settlement':'Aggregator/Online','Discount · separate disclosure':'Discount'};
      return [{...section,title:'Payment Summary',rows:section.rows.map(row=>({...row,label:labels[row.label] || row.label}))}];
    }
    if (section.key?.startsWith('sales-brand-')) {
      return [{...section,rows:section.rows.map(row=>({...row,label:row.label.replace(' · Non-Billing · ',' · ').replace(/ · Billing automatic$/,'')}))}];
    }
    if (section.key === 'payments') return [{...section,title:'Payment Summary',rows:(section.rows || []).map(row=>({...row,label:row.label==='Due Payment'?'Due':row.label}))}];
    if (section.key === 'expenses') return [{...section,title:'Cash Expenses',rows:(section.rows || []).map(row=>({...row,label:row.label==='Total Expenses'?'Total Cash Expenses':row.label}))}];
    if (section.key === 'customer-feedback') return [{...section,title:'Customer Feedback / Issues'}];
    return [section];
  });
}

// Presentation only: consumes authorized Daily Report sections; never fetches data.
export function formatCompleteReport(report) {
  const [year, month, day] = report.report_date.split('-');
  const sections = businessSections(report).map(section => {
    const rows = (section.rows || []).filter(row => {
      if (row.value == null || String(row.value).trim() === '') return false;
      const numeric = typeof row.value === 'number' || row.format === 'money';
      return !numeric || Number(row.value) !== 0 || row.show_when_zero === true;
    }).map(row => `${row.label} - ${row.format === 'money' ? (row.value == null || row.value === '' ? 'Not recorded' : `₹${Number(row.value).toLocaleString('en-IN', {maximumFractionDigits: 2})}`) : String(row.value ?? '')}`);
    const notes = String(section.notes || '').trim();
    if (!rows.length && !notes && section.omit_when_empty !== false) return '';
    return [section.title.toUpperCase(), ...rows, notes].filter(Boolean).join('\n');
  }).filter(Boolean);
  return [[report.business_name, 'DAILY REPORT', `${day}/${month}/${year}`].filter(value => value != null && String(value).trim() !== '').join('\n'), ...sections].join('\n\n');
}

// Called only with the authoritative saved report text, from an explicit user action.
export async function shareSavedText({title,text,nativeShare,copyText}) {
  if (nativeShare) {
    try { await nativeShare({title,text}); return {message:'Report shared.'}; }
    catch (error) {
      if (error.name === 'AbortError') return {message:'Sharing cancelled.'};
    }
  }
  try {
    if (!copyText) throw new Error('Clipboard unavailable');
    await copyText(text);
    return {message:'Report copied.',manualFallback:false};
  } catch (_) {
    return {message:'Automatic copy failed. Select and copy the report below.',manualFallback:true};
  }
}
